import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { TranslateService } from '../../services/translate/translate.service';
import { MangoEventAnalyticsService } from '../../services/mango-events-analytics/mango-events-analytics.service';

interface TranslateNotPasskeys {
  title: string;
  text: string;
  steps: string[];
  close: string;
}

@Component({
  selector: 'lib-modal-not-passkey',
  templateUrl: './modal-not-passkey.component.html',
  styleUrls: ['./modal-not-passkey.component.scss'],
})
export class ModalNotPasskeyComponent implements OnInit, OnDestroy {
  @Output() close = new EventEmitter<boolean>();
  subscriptionTranslate!: Subscription;
  translate!: TranslateNotPasskeys;
  constructor(
    private translateService: TranslateService,
    private mangoEventAnalyticsService: MangoEventAnalyticsService
  ) {}

  ngOnInit(): void {
    this.dataTranslate();
  }

  dataTranslate() {
    this.subscriptionTranslate = this.translateService
      .init('core')
      .subscribe((data) => {
        this.translate = data.login.modalNotPasskeys;
      });
  }

  closeModal() {
    this.mangoEventAnalyticsService.sendEvent('passkeys_info_modal_close', {
      timestamp: new Date().toISOString(),
    });
    this.close.emit(false);
  }

  ngOnDestroy(): void {
    this.subscriptionTranslate?.unsubscribe();
  }
}
